import { useCallback, useEffect } from "react";
import { startPlaybackForegroundService, stopPlaybackForegroundService } from "@/lib/native";

// Iter 102 — SINGLE OWNER of the Android playback foreground service.
// After the Iter 101 crash (the native import silently vanished from
// WaitingRoom during a refactor while call-sites remained), the import,
// start/stop wrappers AND the guaranteed unmount cleanup all live here.
// Both natives are no-ops on web/iOS.
export const useForegroundService = () => {
  const start = useCallback((title) => {
    try { startPlaybackForegroundService(title); } catch (e) { /* never block playback */ }
  }, []);
  const stop = useCallback(() => {
    try { stopPlaybackForegroundService(); } catch (e) { /* ignore */ }
  }, []);
  // Guaranteed cleanup: even if every explicit stop call is lost in a future
  // refactor, unmounting the session screen stops the service.
  useEffect(() => stop, [stop]);
  return { start, stop };
};
